import Image from "./image";
import PreviewInner from "./previewInner";
import Preview from "./preview";
// import '@douyinfe/semi-foundation/lib/es/image/image.css';
export default Image;
export { PreviewInner, Preview };